<template>
    <footer class="footer mt-auto bg-primary pt-3">
        <b-navbar type="dark" class="footer__navbar">
            <b-container class="d-flex justify-content-center">
                <b-navbar-nav class="d-flex justify-content-between flex-wrap">
                    <b-nav-item
                        v-for="(item, i) in footerMenu"
                        class="col-sm-3 col-md-auto"
                        :class="{ 'mr-3': i !== footerMenu.length - 1 }"
                        exact-active-class="active"
                        :key="i"
                        :to="item.to"
                        @click="resetLotPage"
                    >{{ item.name }}</b-nav-item>
                </b-navbar-nav>
            </b-container>
        </b-navbar>
        <b-container>
            <div class="mt-5 mb-5 flex-wrap">
                <div class="d-flex justify-content-center flex-wrap mb-2">
                    <p class="text-light">Связаться с нами – техническая поддержка</p>
                </div>
                <div class="d-flex justify-content-center flex-wrap">
                    <p
                        v-for="contact in contacts"
                        :key="contact.key"
                        class="text-white h6 mx-4 mb-0"
                    >
                        <template v-if="contact.links">
                            <template v-for="link in contact.links">
                                <a
                                    v-if="siteInfo[link.key]"
                                    :href="siteInfo[link.key]"
                                    class="text-light"
                                >
                                    <fa class="mr-2" :icon="link.icon" />
                                </a>
                            </template>
                        </template>

                        <a class="text-light" :href="contact.href">
                            <fa class="mr-2" :icon="contact.icon" />
                            {{contact.value}}
                        </a>
                    </p>
                </div>
            </div>
            <p
                v-if="siteInfo"
                class="text-center text-white footer__text"
            >{{ siteInfo.footer_text }}</p>
        </b-container>
    </footer>
</template>

<script>
import { state } from "../../store";

export default {
    name: "AppFooter",
    props: {
        contacts: Array,
    },
    data() {
        return {
            footerMenu: [
                { name: "Торги", to: { name: "main" } },
                { name: "Регламент", to: { name: "page", params: { type: "reglament" } } },
                { name: "Тарифы", to: { name: "page", params: { type: "price_plans" } } },
                { name: "О площадке", to: { name: "page", params: { type: "about" } } },
                { name: "Обучение", to: { name: "page", params: { type: "user_manual" } } },
                { name: "Вопросы-ответы", to: { name: "faq" } },
                { name: "График работы", to: { name: "page", params: { type: "worktime" } } },
                { name: "Контакты", to: { name: "feedback" } },
            ],
        };
    },
    computed: {
        siteInfo() {
            return state.siteInfo;
        },
    },
    methods: {
        resetLotPage() {
            this.$store.commit('Lots/resetPage')
            this.$store.commit('MyLots/resetPage')
            this.$store.commit('UserLots/resetPage')
        }
    }
};
</script>
